import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import { IntercomProvider } from 'react-use-intercom';
import { IntercomAppId, Production } from './config/Config';
import { Intercom } from './components/utils/Intercom';
import { Analytics } from './components/utils/Analytics';

import {
  OptimizelyProvider,
  createInstance,
} from '@optimizely/react-sdk';
import { Routes } from './Routes';
import { AppContext } from './contexts/AppContext';
import { Optimizely } from './components/utils/Optimizely';
import { ScrollToHashElement } from './utils/ScrollToHashElement';

const optimizelyClient = createInstance({
  sdkKey: Production ? 'UAPfcpfBKHRiqaX9LcoGS' : 'VUZm4PGMRp7g4P7Lb1kG5',
});

export const App: React.FunctionComponent = observer(() => {
  const { UserStore } = useContext(AppContext);

  return (
    <Router>
      <ScrollToHashElement />
      <OptimizelyProvider
        optimizely={optimizelyClient}
        timeout={500}
        user={{ id: UserStore.user?.id.toString() || '0' }}
      >
        <IntercomProvider autoBoot appId={IntercomAppId}>
          <Routes />
          <Intercom />
          <Analytics />
          <Optimizely />
        </IntercomProvider>
      </OptimizelyProvider>
    </Router>
  );
});
